import { JobContentLinkList as JobContentLinkListType } from '@doda/common/src/types/jobSearchList/jobContent/jobContentLink';
import { JobContentLink } from './JobContentLink/index';
import styles from './JobContentLinkList.module.scss';

/**
 * JobContentLinkListのProps
 * @property jobContentLinkLists 求人コンテンツリンク集
 */
interface JobContentLinkListProps {
  jobContentLinkLists: JobContentLinkListType[];
}

/**
 * 求人コンテンツリンクリスト
 */
export const JobContentLinkList = ({
  jobContentLinkLists,
}: JobContentLinkListProps) => {
  if (jobContentLinkLists.length === 0) return null;

  return (
    <div className={styles['job-content-link-list']}>
      {jobContentLinkLists.map((jobContentLinks) => (
        <JobContentLink
          key={jobContentLinks.category}
          jobContentLinks={jobContentLinks}
        />
      ))}
    </div>
  );
};
